import { z } from 'zod';

export const listGrammarTriageQueueV1RequestSchema = z.object({
  cursor: z.coerce.number().int().min(0).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export type IListGrammarTriageQueueV1Request = z.input<
  typeof listGrammarTriageQueueV1RequestSchema
>;
